import { CheckIsApprovalPoolLikeUseCase } from './CheckIsApprovalPoolLikeUseCase'

export const checkIsApprovalPoolLikeUseCase =
  new CheckIsApprovalPoolLikeUseCase().execute
